import { render, staticRenderFns } from "./servicecard.vue?vue&type=template&id=3b6b41ee&scoped=true&"
import script from "./servicecard.vue?vue&type=script&lang=js&"
export * from "./servicecard.vue?vue&type=script&lang=js&"
import style0 from "./servicecard.vue?vue&type=style&index=0&id=3b6b41ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b41ee",
  null
  
)

export default component.exports